module.exports = __webpack_public_path__ + "static/img/logo-brand.4b2b41d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo-brand.png
// module id = mEcH
// module chunks = 215